import { render, staticRenderFns } from "./BotonProcesoTabPreguntas.vue?vue&type=template&id=44caa12e&"
import script from "./BotonProcesoTabPreguntas.vue?vue&type=script&lang=js&"
export * from "./BotonProcesoTabPreguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports